<template>
  <div id="applicator-details">

    <div id="applicator-details-left">

      <button id="applicator-details-back-to-results" class="btn btn-alt-outline" @click.prevent="$root.DeselectApplicator">
        <i class="fa fa-long-arrow-left"></i>
        <span>Back to search results</span>
      </button>

      <div v-if="hasShowcaseProjects" class="applicator-card-showcase">
        <figure class="applicator-card-showcase-slider">
          <div class="applicator-card-showcase-projects" :data-active="activeShowcaseProject">
            <img v-for="n in (applicator.top_project_picture_urls.length)" :src="ImageResize(applicator.top_project_picture_urls[n-1], 700)" :alt="`Featured Project`" />
          </div>
        </figure>
        <div v-if="applicator.top_project_picture_urls !== null && applicator.top_project_picture_urls.length > 1" class="applicator-card-showcase-nav">
          <button v-for="n in (applicator.top_project_picture_urls.length)" :idx="n" :aria-selected="activeShowcaseProject === applicator.top_project_picture_urls[n-1]"  @click.prevent="SetActiveShowcaseProject(n-1)">
            <img :src="ImageResize(applicator.top_project_picture_urls[n-1], 100)" :alt="`Featured Project Thumbnail`" />
          </button>
        </div>
      </div>

      <figure v-else-if="hasBannerImage" class="applicator-card-banner">
        <img :src="applicator.banner_picture_url" />
      </figure>

      <figure v-else class="applicator-card-banner placeholder">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240.76 92.78">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Cerakote_Logos" data-name="Cerakote Logos">
              <g id="Cerakote_White_Gold" data-name="Cerakote White &amp; Gold">
                <rect id="Bar" class="logo-1" y="80.91" width="232.37" height="11.87" />
                <g id="Cerakote">
                  <path class="logo-2" d="M167.21,61a2,2,0,0,0,1.3-.54,1.93,1.93,0,0,0,.63-1.55v-48a2.12,2.12,0,0,0-.59-1.63,1.84,1.84,0,0,0-1.25-.55,2.13,2.13,0,0,0-1.34.55,2,2,0,0,0-.67,1.63v48a1.93,1.93,0,0,0,.63,1.55,2,2,0,0,0,1.29.54m3.72-61c3.44,0,6,.82,7.63,2.47S181,6.92,181,10.88v48c0,4.07-.73,6.91-2.21,8.5s-3.88,2.38-7.22,2.38h-8.17q-5.17,0-7.6-2.51t-2.42-8.37v-48c0-4.07.73-6.9,2.17-8.49S159.41,0,162.75,0Z" />
                  <path class="logo-2" d="M24.77,2.47C23.15.82,20.59,0,17.07,0H9.37q-5,0-7.19,2.39T0,10.88v48q0,5.86,2.43,8.37C4.05,69,6.58,69.8,10,69.8h7.79c3.35,0,5.74-.79,7.2-2.38S27.2,63,27.2,58.92V44.34H15.73V58.92a1.93,1.93,0,0,1-.62,1.55,1.83,1.83,0,0,1-2.6,0,1.93,1.93,0,0,1-.62-1.55v-48a2,2,0,0,1,.66-1.63,2.17,2.17,0,0,1,1.34-.55,1.84,1.84,0,0,1,1.26.55,2.12,2.12,0,0,1,.58,1.63V23H27.2V10.88q0-5.94-2.43-8.41" />
                  <path class="logo-2" d="M100.21,42.68l2.14-28.17,2.13,28.17h-4.27m6.27,26.37h11.38L111.36.92h-18L86.83,69.05H98.22l1.3-17.16h5.66Z" />
                  <polyline class="logo-2" points="211.53 0.92 211.53 69.05 232.37 69.05 232.37 59.86 223.41 59.86 223.41 38.99 231.54 38.99 231.54 29.8 223.41 29.8 223.41 10.11 232.37 10.11 232.37 0.92 211.53 0.92" />
                  <polyline class="logo-2" points="208.76 0.92 183.82 0.92 183.82 10.11 190.35 10.11 190.35 69.05 202.23 69.05 202.23 10.11 208.76 10.11 208.76 0.92" />
                  <polyline class="logo-2" points="152.01 69.05 143.15 33.92 149.14 0.92 137.58 0.92 132.52 30.15 132.52 0.92 120.64 0.92 120.64 69.05 132.52 69.05 132.52 36.94 139.76 69.05 152.01 69.05" />
                  <polyline class="logo-2" points="52.23 10.11 52.23 0.92 31.39 0.92 31.39 69.05 52.23 69.05 52.23 59.86 43.27 59.86 43.27 38.99 51.39 38.99 51.39 29.8 43.27 29.8 43.27 10.11 52.23 10.11" />
                  <path class="logo-2" d="M71.53,32.68a1.94,1.94,0,0,1-1.3.55H68.3V9.63h2a1.83,1.83,0,0,1,1.26.54,2.12,2.12,0,0,1,.59,1.63V31.13a1.93,1.93,0,0,1-.63,1.55m11,1.8c1-1.62,1.54-4.15,1.54-7.61V11.8q0-5.94-2.46-8.41T73.94.92H56.42V69.05H68.3V42.1h1.93a2,2,0,0,1,1.3.54,2,2,0,0,1,.63,1.55V69.05H84V47.81h0c0-3.2-.54-5.6-1.53-7.18a6.9,6.9,0,0,0-5-3.05,7.2,7.2,0,0,0,5-3.1" />
                  <path class="logo-2" d="M234.13,4.59c0-1.95.31-2.67.67-3s.68-.53,1.72-.53h1.85c1,0,1.39.2,1.72.53s.67,1.09.67,3-.31,2.68-.67,3-.68.53-1.72.53h-1.85c-1,0-1.39-.19-1.72-.53S234.13,6.53,234.13,4.59Zm1.23,2.58c.22.24.47.35,1.21.35h1.75c.74,0,1-.11,1.22-.35s.48-.82.48-2.58-.21-2.29-.48-2.58-.48-.34-1.22-.34h-1.75c-.74,0-1,.11-1.21.34s-.48.83-.48,2.58S235.08,6.89,235.36,7.17Zm2.51-1.89c-.05,0-.12-.06-.37-.06H237V6.53h-1.26V2.6h2.55a1.06,1.06,0,0,1,.77.2c.18.17.26.39.26.93,0,.72-.21,1-.68,1h0c.41.08.64.2.65.78,0,.38,0,.77.06,1h-1.27a5.12,5.12,0,0,1-.08-.85C238,5.38,237.93,5.33,237.87,5.28Zm-.25-.94c.23,0,.27,0,.33,0s.08-.14.08-.37,0-.29-.07-.35-.11-.06-.34-.06H237v.83Z" />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </figure>

    </div>

    <div id="applicator-details-right">

      <div class="applicator-card-details-header">

        <div class="applicator-card-details-name">

          <span
            v-for="(labelItem, index) in label"
            v-if="label"
            :key="index"
            :class="`applicator-card-label ${labelItem.class}`"
          >
            <i :class="`fa fa-${labelItem.icon}`"></i>
            {{ labelItem.name }}
          </span>

          <div class="applicator-card-details-rating">
            <i v-for="n in 5" :class="`fa ${n <= applicator.rating ? 'fa-star rated' : 'fa-star-o unrated'}`" :key="`rating-${applicator.user_id}-${n}`"></i>
            <span class="applicator-card-details-rating-count">{{ applicator.review_count }} Reviews</span>
          </div>

          <h2>{{ applicator.company_name }}</h2>

          <div class="applicator-card-details-location">
            <i class="fa fa-map-marker"></i>
            <span>{{ applicator.city ? applicator.city : '' }}</span>
            <span>{{ applicator.region_code ? `, ${applicator.region_code}` : '' }}</span>
          </div>

          <div id="applicator-details-actions">
            <a class="btn btn-alt-outline phone-number" @click="dataLayer.push({'applicatorId': `${applicator.customer_id}`, 'event': 'applicatorPhone'})" :href="PhoneLink(applicator.phone_number)">
              <span class="phone-number-cta">
                <i class="fa fa-phone"></i> Call
              </span>
              <span class="phone-number-display">
                <i class="fa fa-phone"></i> {{ applicator.phone_number }}
              </span>
            </a>
            <a class="btn btn-alt-outline" @click="dataLayer.push({'applicatorId': `${applicator.customer_id}`, 'event': 'applicatorFullProfile'})" :href="profileURL" target="_blank">
              <span>Full Profile</span>
              <i class="fa fa-external-link"></i>
            </a>
          </div>

        </div>

      </div>

      <div v-if="applicator.business_types !== null && applicator.business_types.length > 0" class="applicator-card-info-panel">
        <strong>Business Type:</strong>
        <span>{{ applicator.business_types[0] }}</span>
      </div>

      <div v-if="applicator.work_accepted !== null && applicator.work_accepted.length > 0" class="applicator-card-info-panel">
        <strong>Work Accepted:</strong>
        <ul class="applicator-card-info-panel-pills">
          <li v-for="n in applicator.work_accepted.length">{{ applicator.work_accepted[n-1] }}</li>
        </ul>
      </div>

      <div v-if="certifications !== null && certifications.length > 0" class="applicator-card-info-panel">
        <strong>Production Capabilities:</strong>
        <ul class="applicator-card-info-panel-pills">
          <li v-for="certification in certifications" :key="certification.index">{{ certification }}</li>
        </ul>
      </div>

      <div class="applicator-card-info-panel">
        <strong>Directions:</strong>
        <a rel="nofollow" target="_blank" @click="dataLayer.push({'applicatorId': `${applicator.customer_id}`, 'event': 'applicatorDirections'})" :href="DirectionsLink(applicator.geo_coords)">{{ applicator.formatted_address }}</a>
      </div>

      <div v-if="hasWebsite" class="applicator-card-info-panel">
        <strong>Website:</strong>
        <a rel="nofollow" target="_blank" @click="dataLayer.push({'applicatorId': `${applicator.customer_id}`, 'event': 'applicatorWebsite'})" :href="GenericLink(applicator.website)">{{ GenericLink(applicator.website) }}</a>
      </div>

      <div v-if="hasSocialMedia" class="applicator-card-info-panel">
        <strong>Social Media:</strong>
        <ul class="applicator-card-info-panel-links">
          <li v-if="hasFacebook"><a rel="nofollow" target="_blank" @click="dataLayer.push({'applicatorId': `${applicator.customer_id}`, 'event': 'applicatorFacebook'})" :href="FacebookLink(applicator.facebook_url)">Facebook</a></li>
          <li v-if="hasInstagram"><a rel="nofollow" target="_blank" @click="dataLayer.push({'applicatorId': `${applicator.customer_id}`, 'event': 'applicatorInstagram'})" :href="InstagramLink(applicator.instagram_url)">Instagram</a></li>
          <li v-if="hasTwitter"><a rel="nofollow" target="_blank" @click="dataLayer.push({'applicatorId': `${applicator.customer_id}`, 'event': 'applicatorTwitter'})" :href="TwitterLink(applicator.twitter)">Twitter</a></li>
        </ul>
      </div>

      <div v-if="hasBusinessHours" class="applicator-card-info-panel">
        <strong>Business Hours:</strong>
        <p>{{ applicator.business_hours }}</p>
      </div>

      <div v-if="hasAboutUs" id="applicator-details-about" class="applicator-card-info-panel">
        <h3>About Us</h3>
        <p>{{ applicator.about }}</p>
      </div>

      <div v-if="applicator.loadedReviews !== undefined &&  applicator.loadedReviews !== null && applicator.loadedReviews.length > 0" id="applicator-details-reviews" class="applicator-card-info-panel">
        <h3>Recent Reviews</h3>
        <div v-for="review in applicator.loadedReviews">
          <blockquote class="project-review-quote" :key="review.index">
            <span class="project-review-rating" :title="`Rated ${review.rating} out of 5 stars`">
              <i v-for="n in 5" :class="`fa ${n <= review.rating ? 'fa-star' : 'fa-star-o'}`" :key="`${review.id}-rating-${n}`"></i>
            </span>
            <span>
              <a
                v-if="review.project !== null"
                class="btn btn-default"
                style="pointer-events: all"
                :href="review.project.url"
                target="_blank"
                ><i class="fa fa-external-link" aria-hidden="true"></i> View
                Project</a
              >
            </span>
            <h4>{{ review.title }}</h4>
            <p>{{ review.body }}</p>
            <cite>
              <span>- {{ review.name ? review.name : `${applicator.company_name} Customer` }}</span>
            </cite>
          </blockquote>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
  import ImageMixin from '../../mixins/images';
  import URLMixin from '../../mixins/url';
  import Computed from '../../mixins/applicator-map-utils';

  export default {
    name: 'applicator-details',

    mixins: [ImageMixin, URLMixin, Computed],

    props: {
      applicator: Object,
    },

    data() {
      return {
        activeShowcaseProject: 0,
      };
    },

    async mounted() {
      dataLayer.push({
        applicatorId: `${this.applicator.customer_id}`,
        event: 'applicatorDetailsLoaded',
      });
    },

    methods: {
      SetActiveShowcaseProject(key) {
        this.activeShowcaseProject = key;
      },
    },
  };
</script>

<style lang="scss">
  #applicator-details {
    width: calc(var(--sidebar-width) + var(--applicator-filters-width));
    margin-left: calc(var(--applicator-filters-width) * -1);
    padding: var(--sidebar-padding);
    background-color: #f9fafc;
    align-items: flex-start;
    flex-direction: row;
    min-height: 100%;
    display: flex;
    z-index: 2;

    &-back-to-results {
      margin-bottom: 16px;
    }

    @media screen and (max-width: 1500px) {
      flex-direction: column;
      width: 100%;
      margin: 0;
    }

    a:not([class]) {
      &:hover,
      &:focus {
        text-decoration: underline;
      }
    }

    &-left,
    &-right {
      flex-direction: column;
      display: flex;
    }

    &-left {
      top: calc(var(--desktop-header-size) + var(--sidebar-padding));
      padding-right: calc(var(--sidebar-padding) / 2);
      position: sticky;
      flex: 1 0 55%;
      width: 55%;

      @media screen and (max-width: 1500px) {
        position: relative;
        flex: 1 0 auto;
        width: 100%;
        padding: 0;
        top: auto;
      }
    }

    &-right {
      padding-left: calc(var(--sidebar-padding) / 2);
      flex: 1 0 45%;
      width: 45%;

      @media screen and (max-width: 1500px) {
        flex: 1 0 auto;
        width: 100%;
        padding: 0;
      }
    }

    .applicator-card-showcase,
    .applicator-card-banner {
      margin: 0 0 22px;
      width: 100%;
    }

    .applicator-card-banner,
    .applicator-card-showcase-slider {
      border-bottom-right-radius: var(--applicator-border-radius);
      border-bottom-left-radius: var(--applicator-border-radius);
    }

    .applicator-card-banner {
      padding-bottom: 56.25%;

      @media screen and (max-width: 1500px) {
        margin: 0 0 22px;
      }
    }

    .applicator-card-showcase-slider {
      margin: 0;
    }

    .project-review-quote {
      margin: 16px 0 0 0;

      p {
        -webkit-line-clamp: initial;
        text-overflow: initial;
        overflow: initial;
        max-height: none;
        font-size: 14px;
      }
    }

    &-actions {
      flex-direction: row;
      margin-top: 16px;
      display: flex;
      width: 100%;

      > .btn {
        margin: 0;
        flex: 1;

        + .btn {
          margin-left: 16px;
        }
      }

      @media screen and (max-width: 1024px) {
        flex-direction: column;

        > .btn {
          flex: auto;

          + .btn {
            margin-top: 12px;
            margin-left: 0;
          }
        }
      }
    }
  }
</style>
